<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Unidade</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-2">
                      <label for="codigo_cliente">
                        Código do cliente:
                      </label>
                      <input type="text" id="codigo_cliente" class="form-control" readonly
                        :value="unidade.codigo_cliente" placeholder="Gerado ao salvar" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="nome">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="nome" class="form-control"
                        v-model="unidade.nome" placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="tipo_unidade_id">
                        <span class="required">*</span> Tipo Unidade:
                      </label>
                      <v-select :options="tipo_unidades" :label="'nome'" :reduce="(tipo_unidades) => tipo_unidades.id"
                        v-model="unidade.tipo_unidade_id"></v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="glpi_localizacao_id">Localização GLPI:</label>
                      <v-select
                        :options="localizacoesGlpi"
                        label="nome_completo"
                        :reduce="(localizacao) => localizacao.id"
                        v-model="unidade.glpi_localizacao_id"
                        placeholder="Nenhuma"
                      >
                        <template #no-options>Nenhuma localização - sincronize com o GLPI na lista de unidades</template>
                      </v-select>
                    </div>
                    <div class="form-group col-md-1">
                      <label for="status">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="unidade.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/unidades" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      unidade: {
        status: '1',
      },
      tipo_unidades: [],
      localizacoesGlpi: [],
      errors: undefined,
    };
  },
  methods: {

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("nome", self.unidade.nome);
      fd.append("tipo_unidade_id", self.unidade.tipo_unidade_id == null ? "" : self.unidade.tipo_unidade_id);
      fd.append("glpi_localizacao_id", self.unidade.glpi_localizacao_id || "");
      fd.append("status", self.unidade.status);

      fd.append("_method", "POST");

      if (self.unidade.id) {
        fd.append("id", self.unidade.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "unidades";
      let fd = self.makeFormData();

      if (self.unidade.id) {
        self.unidade._method = "PUT";
        api += "/" + self.unidade.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Informações guardadas com sucesso`, "success");
          this.$router.push("/unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getModeloPergunta: function (id) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getLocalizacoesGlpi: function () {
      axios
        .get(this.$store.state.api + "glpi/localizacoes")
        .then((response) => {
          this.localizacoesGlpi = response.data.data;
        })
        .catch(() => {});
    },
    getTipoUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_unidades";

      axios
        .get(api)
        .then((response) => {
          self.tipo_unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getTipoUnidades();
    self.getLocalizacoesGlpi();
    let id = self.$route.params.id;
    if (id) {
      self.getModeloPergunta(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
